/**
 * /api/user/host_shared/vhosts(/:id) row → flat fields the list/detail render.
 * Usage lives in the quota relation (disk MB, bandwidth GB/month — same source as the dashboard card);
 * status is numeric (1 = running, 0 = suspended).
 */
const num = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
};

export const isVhostActive = (status) => status === 1 || status === '1' || status === true || status === 'active';

export const normalizeVhost = (raw) => {
    if (!raw || raw.pending) return raw;
    const q = raw.quota || {};
    const domains = Array.isArray(raw.domains) ? raw.domains : [];
    const primary = domains.find((d) => d && (d.is_primary || d.type === 'primary')) || domains[0];
    return {
        ...raw,
        active: isVhostActive(raw.status),
        domain: raw.domain || primary?.domain || null,
        disk_quota: num(q.disk_quota),
        disk_usage: num(q.disk_used),
        bandwidth_quota: num(q.bandwidth_quota),
        bandwidth_usage: num(q.bandwidth_used),
        domain_quota: q.domain_quota === undefined || q.domain_quota === null ? null : num(q.domain_quota),
        ftp_quota: num(q.ftp_quota),
        domains_count: raw.stats?.domains_count ?? domains.length,
        databases_count: raw.stats?.databases_count ?? (Array.isArray(raw.databases) ? raw.databases.length : 0),
    };
};

export const usagePercent = (used, quota) => (quota > 0 ? Math.min(100, Math.round((used / quota) * 100)) : 0);
